
import React from "react";
import { api } from "api";
import Swal from "sweetalert2";
import { Field, change } from "redux-form";
import { renderNumber } from "../../Utils/renderField";
import { SelectField } from "../../Utils/renderField/renderField";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { requiredField } from "../../../../utility/validation";

const validateKm = (value, allValues, props, name) => {
    if (!name || value === undefined || value === null || value === '') return undefined;
    const match = name.match(/members\[(\d+)\]/);
    if (match && allValues.members && allValues.members[match[1]]) {
        const item = allValues.members[match[1]];
        const initialKm = item.km_inicial;
        // Strip commas and parse — handles "179,010.00" from backend or typed input
        const val = parseFloat(String(value).replace(/,/g, ""));
        const ini = parseFloat(String(initialKm).replace(/,/g, ""));
        // Only validate when both are valid complete numbers
        if (!isNaN(val) && !isNaN(ini) && val > 0 && ini > 0 && val < ini) {
            return "El KM final no debe ser menor a KM inicial";
        }
    }
    return undefined;
};

const renderVehicles = ({
    fields,
    meta: { touched, error, submitFailed },
    vehicles,
    isView,
    temporal_vehicle,
    setTemporalVehicle,
    selected_vehicles,
    setSelectedVehicles,
    pilot,
    role,
    dispatch,
}) => {
    const addVehicle = () => {
        if (!temporal_vehicle) {
            Swal.fire("¡Atención!", "Debes seleccionar un vehículo.", "warning");
        } else {
            if (!selected_vehicles.find((e) => e.value == temporal_vehicle.value)) {
                fields.push({
                    km_inicial: temporal_vehicle.last_mileage || 0,
                    pilot: null, // As requested, field must start empty, not inherit last pilot
                    enable_tracking: false
                });
                setSelectedVehicles((a) => [...a, temporal_vehicle]);
                setTemporalVehicle(null);
                // Clear the dropdown selection after adding
                dispatch(change("EmergencyForm", "vehicles", null));
            } else {
                Swal.fire("¡Atención!", "Ya has agregado este vehículo.", "warning");
            }
        }
    };

    const selectVehicle = (vehicle_id) => {
        if (!vehicle_id) {
            setTemporalVehicle(null);
            return;
        }
        api.get(`vehicle/last_mileage`, { vehicle_id })
            .then((response) => {
                const vehicle = vehicles.find((e) => e.value == vehicle_id);
                if (vehicle) {
                    setTemporalVehicle({
                        ...vehicle,
                        last_mileage: response.final_mileage,
                        pilot_id: response.pilot_id || null, // Store pilot_id in temporal_vehicle
                    });
                }
            })
            .catch(() => {
                setTemporalVehicle(vehicles.find((e) => e.value == vehicle_id));
            });
    };

    const removeVehicle = (index) => {
        let vs = [...selected_vehicles];
        vs.splice(index, 1);
        fields.remove(index);
        setSelectedVehicles(vs);
    };

    return (
        <React.Fragment>
            <div className="col-12 col-md-6 form-group">
                <label htmlFor="vehicles">Vehículo</label>
                <Field
                    name="vehicles"
                    label="vehicles"
                    placeholder="Vehículo"
                    disabled={isView}
                    options={vehicles}
                    component={SelectField}
                    className="form-control"
                    customOnChange={selectVehicle}
                />
            </div>
            <div className="col-12 col-md-6 form-group d-flex align-items-end">
                <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => addVehicle()}
                >
                    Agregar Vehículo
                </button>
            </div>
            <div className="col-12 form-group">
                {fields.length > 0 ? (
                    <React.Fragment>
                        {/* Desktop View (Table) */}
                        <div className="d-none d-md-block table-responsive">
                            <Table className="table">
                                <Thead>
                                    <Tr className="table-primary text-white">
                                        <Th>#</Th>
                                        <Th>Placa - Nombre</Th>
                                        <Th style={{ width: '150px' }}>KM Inicial</Th>
                                        <Th style={{ width: '150px' }}>KM Final</Th>
                                        <Th>Piloto</Th>
                                        <Th>Acciones</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {fields.map((member, index) => {
                                        const vehicle = selected_vehicles[index];
                                        return (
                                            <Tr key={vehicle ? vehicle.value : index}>
                                                <Td>{index + 1}</Td>
                                                <Td>{vehicle ? vehicle.label : ""}</Td>
                                                <Td>
                                                    <Field
                                                        name={`${member}.km_inicial`}
                                                        placeholder="KM inicial"
                                                        type="number"
                                                        component={renderNumber}
                                                        disabled={isView}
                                                        validate={[requiredField]}
                                                    />
                                                </Td>
                                                <Td>
                                                    <Field
                                                        name={`${member}.km_final`}
                                                        type="number"
                                                        placeholder="KM final"
                                                        disabled={isView}
                                                        component={renderNumber}
                                                        validate={[validateKm, requiredField]}
                                                    />
                                                </Td>
                                                <Td>
                                                    <Field
                                                        name={`${member}.pilot`}
                                                        placeholder="Piloto"
                                                        disabled={isView}
                                                        options={pilot}
                                                        component={SelectField}
                                                        className="form-control"
                                                    />
                                                </Td>
                                                <Td>
                                                    {!isView && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-remove-custom"
                                                            onClick={() => removeVehicle(index)}
                                                        >
                                                            <span className="material-icons">close</span>
                                                        </button>
                                                    )}
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </div>

                        {/* Mobile View (Cards) */}
                        <div className="d-md-none vehicle-card-container">
                            {fields.map((member, index) => {
                                const vehicle = selected_vehicles[index];
                                return (
                                    <div key={vehicle ? vehicle.value : index} className="vehicle-card">
                                        <span className="vehicle-card-header">{index + 1}</span>
                                        
                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">Placa - Nombre</label>
                                            <span className="vehicle-field-value-text">
                                                {vehicle ? vehicle.label : ""}
                                            </span>
                                        </div>

                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">KM Inicial <span className="text-danger">*</span></label>
                                            <div className="vehicle-field-value">
                                                <Field
                                                    name={`${member}.km_inicial`}
                                                    placeholder="KM inicial"
                                                    type="number"
                                                    component={renderNumber}
                                                    disabled={isView}
                                                    validate={[requiredField]}
                                                />
                                            </div>
                                        </div>

                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">KM Final <span className="text-danger">*</span></label>
                                            <div className="vehicle-field-value">
                                                <Field
                                                    name={`${member}.km_final`}
                                                    type="number"
                                                    placeholder="KM final"
                                                    disabled={isView}
                                                    component={renderNumber}
                                                    validate={[validateKm, requiredField]}
                                                />
                                            </div>
                                        </div>

                                        <div className="vehicle-field-row">
                                            <label className="vehicle-field-label">Piloto <span className="text-danger">*</span></label>
                                            <div className="vehicle-field-value">
                                                <Field
                                                    name={`${member}.pilot`}
                                                    placeholder="Piloto"
                                                    disabled={isView}
                                                    options={pilot}
                                                    component={SelectField}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>

                                        {!isView && (
                                            <div className="vehicle-field-row">
                                                <label className="vehicle-field-label">Acciones</label>
                                                <div className="vehicle-field-value">
                                                    <button
                                                        type="button"
                                                        className="btn btn-remove-custom"
                                                        onClick={() => removeVehicle(index)}
                                                    >
                                                        <span className="material-icons">close</span>
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </React.Fragment>
                ) : (
                    <p>Seleccione un vehículo y presione el botón 'Agregar Vehículo'.</p>
                )}
            </div>
        </React.Fragment>
    );
};

export default renderVehicles;
